module.exports = __webpack_public_path__ + "cdf7b79f44151029038eaa26e9c7a9d9.png";